module.exports = __webpack_public_path__ + "img/MY-A2K4060B-BD.c299eacc.png";